import { makeStyles } from "@material-ui/styles";

const timePickerStyles = makeStyles(() => ({
	input: {
		backgroundColor: "#FFF",
		flexWrap: "nowrap"
	},
	label: {
		color: "#767676",
		fontSize: "0.77rem"
	},
	labelPlacementTop: {
		margin: 0
	},
	autocomplete: {
		width: 75,
		"& input": {
			textAlign: "center"
		}
	},
	separator: {
		margin: 10,
		paddingTop: 7
	},
	textOverflow: {
		textOverflow: "ellipsis",
		overflow: "hidden",
		whiteSpace: "nowrap",
		width: 70
	},
	errorMessage: {
		maxWidth: 200
	},
	flexColumn: {
		flexDirection: "column"
	},
	justifyCenter: {
		justifyContent: "center"
	},
	endAdornment: {
		margin: 0
	},
	dashedInput: {
		"& .MuiOutlinedInput-notchedOutline": {
			borderStyle: "dashed",
			borderColor: "rgba(0, 0, 0, 0.23) !important"
		}
	},
	clockTimePicker: {
		"& .MuiPickersToolbar-toolbar": {
			backgroundColor: "#202D43"
		},
		"& .MuiButton-containedPrimary:nth-child(1)": {
			backgroundColor: "#fff",
			color: "#333333",
			border: "1px solid rgba(232, 232, 232, 0.5)"
		},
		"& .MuiPickersClockPointer-pointer, & .MuiPickersClock-pin": {
			backgroundColor: "#202D43"
		},
		"& .MuiPickersClockPointer-thumb": {
			border: "14px solid #202D43"
		},
		"& .MuiPickersClockPointer-noPoint": {
			backgroundColor: "#202D43"
		}
	},
	clockTimePickerBox: {
		width: "100%",
		display: "flex",
		justifyContent: "center"
	},
	hiddenDialog: {
		"& button": { display: "none" }
	}
}));

export default timePickerStyles;
